// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__hMP9A","header":"PatientBlock_header__1di2y","label":"PatientBlock_label__3-OsH","option":"PatientBlock_option__2-Uu8"};